import { Form } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  AuthFormComponent,
  CustomButton,
  TextInput,
  Notification,
} from "../../components";
import { LoginCredentials } from "../../models/login_credentials";
import { submitUserRequest } from "../../store/slices/user-slice";
import { AppDispatch, RootState } from "../../store/types/store";

const Login: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [notification, setNotification] = useState<{
    message: string;
    messageType: string;
  } | null>(null);
  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { signInResponse, loading, isAuthenticated, error } = useSelector(
    (state: RootState) => state.user
  );

  const onFinish = async (values: LoginCredentials) => {
    try {
      const validatedValues = await form.validateFields();
      console.log(
        "All fields are valid. Submitting form with values:",
        validatedValues
      );
      const payload = {
        email: values.email,
        password: values.password,
      };
      dispatch(submitUserRequest(payload));
    } catch (error) {
      console.log("Validation failed:", error);
    }
  };

  useEffect(() => {
    if (signInResponse) {
      if (signInResponse.message === "Success") {
        localStorage.setItem("user", JSON.stringify(signInResponse.body));
        localStorage.setItem("isAuthenticated", isAuthenticated.toString());
        setNotification({ message: "Login successful!", messageType: "success" });
        navigate("/dashboard");
      }
    }
    
    if (error == "Email/Password invalid!") {
      setNotification({ message: "Email or Password is invalid", messageType: "error" });
    }

    if(error == "Unapproved user!") {
      setNotification({ message: "Please wait until the user is approved", messageType: "warning" });
    }
  }, [signInResponse, error]);

  return (
    <AuthFormComponent
      header={"Symmatics Core"}
      description={
        "Login to access your account and manage Symmatics core functionalities"
      }
      title="Login"
    >
      <Form
        form={form}
        name="normal_login"
        onFinish={onFinish}
        autoComplete="off"
      >
        <TextInput
          className={"mb-3"}
          name="email"
          rules={[
            {
              required: true,
              type: "email",
              message: "Please input your email!",
            },
          ]}
          placeholder="Enter your email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          label="Email Address"
        />
        <TextInput
          className={"mb-3"}
          name="password"
          password
          rules={[{ required: true, message: "Please input your password!" }]}
          placeholder="Enter your password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          label="Password"
        />
        <CustomButton
          wrapperClass="d-grid"
          btnType={"primary"}
          btnClass="btn-secondary"
          btnText="Login"
          loading={loading}
          disabled={loading}
        />
        <div className="mt-3 text-center">
          Don't have an account? &nbsp;
          <Link to={"/signup"} className="text-decoration-none link-muted">
            Sign Up
          </Link>
        </div>
        <div className="mt-3 text-center">
          <Link
            to={"/forgotpassword"}
            className="text-decoration-none link-muted"
          >
            Forgot password?
          </Link>
        </div>
      </Form>
      {notification && (
        <Notification
          message={notification.message}
          messageType={notification.messageType}
          onClose={() => setNotification(null)}
        />
      )}
    </AuthFormComponent>
  );
};

export default Login;
